import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  WalletApprovePayload,
  WalletRejectPayload,
  WalletCreateResponse,
  WalletFilters,
  WalletTransferPayload,
  WalletTopupRequest,
  WalletRequestListResponse,
  WalletWithdrawalRequest,
} from "../types/wallet-request.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.walletTopup;

export const walletTopupService = {
  async list(filter: WalletFilters): Promise<WalletRequestListResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<WalletRequestListResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to load wallet top-up requests due to an unexpected error.",
        data: {},
        resData: null,
      } as unknown as WalletRequestListResponse;
    }
  },

  // Same endpoint for both request types (transfer / withdrawal)
  async create(payload: WalletTopupRequest | WalletTransferPayload | WalletWithdrawalRequest): Promise<WalletCreateResponse> {
    try {
      return await apiClient<WalletCreateResponse>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to create wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },

  async approve(requestRef: string, payload: WalletApprovePayload): Promise<WalletCreateResponse> {
    try {
      return await apiClient<WalletCreateResponse>(endpoints.approve(requestRef), {
        method: "PUT",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to approve wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },

  async reject(requestRef: string, payload: WalletRejectPayload): Promise<WalletCreateResponse> {
    try {
      return await apiClient<WalletCreateResponse>(endpoints.reject(requestRef), {
        method: "PUT",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to reject wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },
};
